export const relationSBICategory = {
    ProyectosEmisiones:{
        group: "Proyectos y emisiones",
        column: 0,
        order: 1
    },
    HojaMediador: { 
        group: "Hoja información previa del mediador",
        column: 0,
        order: 2
    },
    AnalisisdeNecesidades: { 
        group: "Análisis de necesidades",
        column: 0,
        order: 3
    },
    ProductosVida: { 
        group: "Productos Vida",
        column: 0,
        order: 4
    },
    ProductosNoVida: { 
        group: "Productos Seguros Generales",
        column: 1,
        order: 1
    },
    ProdOrbVida: { 
        group: "Productos Vida Órbita",
        column: 0,
        order: 5
    },
    ProductosSegurosGeneralesOrbita: { 
        group: "Productos Seguros Generales Orbita",
        column: 1,
        order: 2
    }
};